import { EventBus } from '../event-bus';
import { mapGetters } from 'vuex';
import { CORE_VERSION } from '@/lib/constants/env';
import { responseErrorHelper } from '@/lib/http';
import {
  CREATE_FORM_SUBTITLE,
  UPDATE_FORM_SUBTITLE,
  MEMBER_CATEGORIES
} from '@/lib/constants/options';
import _ from 'lodash'

export default {
  data() {
    return {
      CREATE_FORM_SUBTITLE: CREATE_FORM_SUBTITLE,
      UPDATE_FORM_SUBTITLE: UPDATE_FORM_SUBTITLE,
      MEMBER_CATEGORIES,
      FORECLOSURE_STATUS: {
        MARKED_FOR_FORECLOSURE: 'MARKED_FOR_FORECLOSURE',
        FORECLOSURE_CONFIRMED: 'FORECLOSURE_CONFIRMED',
        FORECLOSURE_REJECTED: 'FORECLOSURE_REJECTED',
        FORECLOSURE_CASE_CLOSED: 'FORECLOSURE_CASE_CLOSED',
        BAILIFF: 'BAILIFF',
        COLLECTOR: 'COLLECTOR',
        LEGAL: 'LEGAL',
        PENDING_SALE: 'PENDING_SALE',
        ASSET_REGISTERED: 'ASSET_REGISTERED',
        ASSET_SOLD: 'ASSET_SOLD'
      }
    };
  },
  computed: {
    ...mapGetters('coreModule', [
      'activeCompany',
      'activeBranches',
      'branches',
      'apps'
    ]),
    ...mapGetters('authModule', ['user', 'userFullName']),

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    version() {
      return CORE_VERSION;
    }
  },

  methods: {
    /**
     * Copy text to system clipboard 
     * @param { string } text
     */
    copyTextToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.showSnack({
        color: 'info',
        title: 'Copied to clipboard',
      })
    },
    /**
     * This is used to display an snack alert to the user
     * @param {*} options
     */
    showSnack: (options) => {
      EventBus.$emit('SHOW_SNACK', options);
    },

    /**
     * This is used to get the color based on the value
     *
     * @param {Number} value - The value to be checked
     * @param {Number} badThreshold - The bad threshold. This returns the color red
     * @param {Number} mediumThreshold - The medium threshold. This returns the color orange
     * @param {Number} goodThreshold - The good threshold. This returns the color green
     * @returns {String} - The color to be used
     */
    getStatusColor(value, badThreshold, mediumThreshold, goodThreshold) {
      value = Number(value);
      if (isNaN(value)) value = 0;
      if (value < goodThreshold) return 'green';
      if (value >= goodThreshold && value < mediumThreshold) return 'green';
      if (value >= mediumThreshold && value < badThreshold) return 'orange';
      if (value >= badThreshold) return 'red';
      return '';
    },

    /**
     * Method used to add a query to the url
     * @param {String} key - The query key
     * @param {String} value - The query value
     */
    addQueryToUrl(data, value) {
      this.$router.push({
        query: {
          ...this.$route.query,
          [data]: value
        }
      });
    },

    httpErrorHandler(error, { title, message } = { title: '', message: '' }) {
      const err = responseErrorHelper(error);
      let resData = error.response.data;

      const extractData = (input) => {

        // 1) Raw string → message only
        if (typeof input === 'string') {
          return { title: null, message: input };
        }

        // 2) Array → dive into first element
        let obj;
        if (Array.isArray(input)) {
          if (input.length === 0) {
            return { title: null, message: null };
          }
          obj = input[0];
        }
        // 3) Single object → use it directly
        else if (input && typeof input === 'object') {
          obj = input;
        }
        else {
          throw new Error('Unsupported input type. Expected string, object, or array.');
        }

        // 4) Extract title
        const title = (typeof obj.title === 'string' ? obj.title : null);

        // 5) Normalize message
        let message = null;
        const msg = obj.message;

        if (typeof msg === 'string') {
          message = msg;
        }
        else if (Array.isArray(msg) && msg.length > 0) {
          const first = msg[0];
          if (typeof first === 'string') {
            message = first;
          }
          else if (first && typeof first === 'object' && typeof first.message === 'string') {
            message = first.message;
          }
        }

        return { title, message };
      }

      const { title: resTitle, message: resMessage } = extractData(resData.message);

      return this.showSnack({
        timeout: 12000,
        color: 'error',
        title: title || resTitle || 'Something went wrong',
        message: message || resMessage
      })
    }
  }
};
